import Component from "@glimmer/component";
import { task, Task } from "ember-concurrency";
import { arg, forbidExtraArgs } from "glesys-controlpanel/utils/arg";
import { shape, instanceOf } from "prop-types";
import { tracked } from "@glimmer/tracking";
import { on } from "@ember/modifier";
import { not } from "ember-truth-helpers";
import { t } from "ember-intl";
import Header from "glesys-controlpanel/components/g-modal/header";
import Body from "glesys-controlpanel/components/g-modal/body";
import Footer from "glesys-controlpanel/components/g-modal/footer";
import modalClose from "glesys-controlpanel/helpers/modal-close";
import GButton from "glesys-controlpanel/components/g-button";
import GInput from "glesys-controlpanel/components/g-input";
import Label from "glesys-controlpanel/components/label";
import TaskForm from "glesys-controlpanel/components/task-form";
import PasswordReveal from "glesys-controlpanel/components/password-reveal";

@forbidExtraArgs
export default class ModalsDatabaseCreateUser extends Component {
  @arg(
    shape({
      task: instanceOf(Task).isRequired,
    }).isRequired,
  )
  params;

  @tracked username = "";

  get canSubmit() {
    return this.username.trim().length > 0;
  }

  onChange = ({ username }) => (this.username = username);

  onSubmitTask = task(async () => {
    return await this.params.task.perform(this.username.trim());
  });

  <template>
    {{#if this.onSubmitTask.lastSuccessful}}
      <Header>
        {{t "databases.details.users.created.title" username=this.onSubmitTask.lastSuccessful.value.username}}
      </Header>
      <Body data-test-modal-database-create-user-success>
        <PasswordReveal @password={{this.onSubmitTask.lastSuccessful.value.password}} />
      </Body>
      <Footer>
        <GButton data-test-modal-database-create-user-done @color="blue" {{on "click" (modalClose)}}>
          {{t "databases.details.users.created.done"}}
        </GButton>
      </Footer>
    {{else}}
      <Header>{{t "databases.details.users.create.title"}}</Header>
      <Body>
        <p class="text-gray-500 pb-6">{{t "databases.details.users.create.description"}}</p>
        <TaskForm id="create-user-form" @onChange={{this.onChange}} @task={{this.onSubmitTask}}>
          <Label for="create-user-username">{{t "databases.details.users.create.username-label"}}</Label>
          <GInput
            id="create-user-username"
            data-test-modal-database-create-user-username
            name="username"
            value={{this.username}}
            placeholder={{t "databases.details.users.create.username-placeholder"}}
          />
        </TaskForm>
      </Body>
      <Footer>
        <GButton class="mr-2" data-test-cancel-button @color="gray" {{on "click" (modalClose)}}>
          {{t "button.cancel"}}
        </GButton>
        <GButton
          data-test-modal-database-create-user-submit
          @type="submit"
          @color="blue"
          @loading={{this.onSubmitTask.isRunning}}
          @disabled={{not this.canSubmit}}
          form="create-user-form"
        >
          {{t "databases.details.users.create.submit"}}
        </GButton>
      </Footer>
    {{/if}}
  </template>
}
